var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",staticStyle:{"height":"100%"},attrs:{"id":"welcome"}},[(_vm.show)?_c('welcome-message',{staticClass:"align-center justify-center"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }